import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-icon-toggle-theme-dark',
  templateUrl: './icon-toggle-theme-dark.component.html',
  styleUrl: './icon-toggle-theme-dark.component.scss'
})
export class IconToggleThemeDarkComponent {

}
